import { MappedField } from 'libs/datagrid/src/lib/containers/dx-datagrid/dx-datagrid.types';
import { VendorsDetails } from '../store/vendors-list/vendors-list.types';
import { hasAllowedFields } from './field-structure.utils';
export type VendorsFields = {
  /**
   * Required for commit form
   */
  controlType?: VendorsPlaceHolderTypeVal;
  /**
   * Shows dataType tah
   */
  dataType?: VendorsPlaceHolderTypeVal;
  editType?: string;
  /**
   * Shows if field should be excluded in specific forms
   */
  exclude?: VendorsPlaceHolderTypeVal;
  exclusive?: string;
  format?: string;
  /**
   * Shows the name that should be displayed in forms
   */
  headerText?: VendorsPlaceHolderTypeVal;

  /**
   * Used as field in forms
   */
  id: VendorsPlaceHolderTypeVal;
  /**
   * (Datagrid)
   */
  isPrimaryKey?: boolean;
  /**
   * Shows if the field is mandatory in forms
   */
  isRequired?: VendorsPlaceHolderTypeVal;
  /**
   * Shows if it should be visible by default in forms
   */
  visible?: VendorsPlaceHolderTypeVal;
};

type DatagridInfo = {
  /**
   * @description Sets index of commit by finding it fromAPI response
   */
  index?: number;
  /**
   * @description Indicates if we need to set page number by finding it from API response
   */
  isPageNumberNeeded?: boolean;
  /**
   * @description Sets directly from datagrid (No need to find it from API response)
   */
  pageNumber?: number;
};

export enum EnumVendorsViews {
  INFO = 0,
  EDIT = 1,
  CONTACTS = 2,
  PN = 3,
  BUYERS = 4,
  NOTIFICATION = 5,
  NOTES = 6,
  COMMENTS = 7,
  CONFIG = 8,
}

export enum EnumVendorInfoViews {
  LIST = 0,
  SINGLE_COLUMN = 1,
  MULTI_COLUMN = 2,
  RESPONSIVE_COLUMN = 3,
}

export enum EnumVendorPNViews {
  SIMPLE_TABLE = 0,
  GROUP_TABLE = 1,
}

//TODO Change name
export type VendorsPlaceHolderTypeVal = {
  createForm?: boolean | number | string;
  datagrid?: boolean | number | string;
  editForm?: boolean | number | string;
  nestedBuyerForm?: boolean | number | string;
  nestedForm?: boolean | number | string; //use nested<component>form for specific Component
  nestedNotificationForm?: boolean | number | string;
};

export type createVendor = {
  approvedVendorByCustomer?: boolean;
  contact?: {
    email?: string;
    phone?: number;
  };
  flag?: string; // only for create vendor with flag
  meansOfCommitting: string;
  partnerMode?: boolean;
  sectionName?: string;
  selfBilling: string;
  transportationPaidBy?: string;
  vat?: string;
  vendorCode: string;
};

export type VendorsContacts = {
  contactType?: string;
  email?: string;
  firstName?: string;
  identityKey?: string;
  key?: string;
  lastName?: string;
  name?: string;
};

export type notificationEmails = {
  description?: string;
  emailTo?: string[];
  emailToBCC?: string[];
  emailToCC?: string[];
  id: string;
  key: string;
  name: string;
};

export type VendorTransactionDetails = {
  data?: VendorsDetails;
  datagridInfo?: DatagridInfo;
  id: string;
  type?: EnumVendorType;
};

export enum EnumVendorType {
  NEW = 0,
  EDIT = 1,
}

export enum EnumVendorsFieldStructure {
  VendorTable = 0,
  VendorCreateForm = 1,
  VendorEditForm = 2, //IF MORE FORM CHANGE NAME
  NestedTable = 3,
  NestedForm = 4,
  NestedBuyerTable = 5,
  NestedBuyerForm = 6,
  NestedContactsTable = 7,
  NestedNotificationTable = 8,
  NestedNotificationForm = 9,
}

export class VendorsListField {
  fields: MappedField[];
  userRightFields: string[] = [];
  hasField: (
    field: VendorsFields,
    refId: keyof VendorsPlaceHolderTypeVal,
    actualId: keyof VendorsPlaceHolderTypeVal,
  ) => boolean;

  constructor(type?: EnumVendorsFieldStructure, userRightFields?: string[]) {
    if (hasAllowedFields(userRightFields)) {
      this.userRightFields = userRightFields.map((e): string => e.toLowerCase());
      this.hasField = this.validFunWithUserFields;
    } else {
      this.hasField = this.validFunWithoutUserFields;
    }
    this.fields = this.getDefaultFields(type);
  }

  getDefaultFields(type?: EnumVendorsFieldStructure): MappedField[] {
    switch (type) {
      case EnumVendorsFieldStructure.VendorTable:
        return this.getDatagridFields();
      case EnumVendorsFieldStructure.VendorCreateForm:
        return this.getCreateFormList();
      case EnumVendorsFieldStructure.VendorEditForm:
        return this.getEditFormList();
      case EnumVendorsFieldStructure.NestedTable:
        return this.getVendorPnFields();
      case EnumVendorsFieldStructure.NestedForm:
        return this.getPnFormFields();
      case EnumVendorsFieldStructure.NestedBuyerTable:
        return this.getVendorBuyerFields();
      case EnumVendorsFieldStructure.NestedBuyerForm:
        return this.getBuyerFormFields();
      case EnumVendorsFieldStructure.NestedNotificationTable:
        return this.getVendorNotificationFields();
      case EnumVendorsFieldStructure.NestedNotificationForm:
        return this.getNotificationFormFields();
      case EnumVendorsFieldStructure.NestedContactsTable:
        return this.getVendorContactsFields();
      default:
        return this.getDatagridFields();
    }
  }

  validFunWithUserFields = (
    field: VendorsFields,
    refId: keyof VendorsPlaceHolderTypeVal,
    actualId: keyof VendorsPlaceHolderTypeVal,
  ): boolean => {
    if (this.userRightFields && !(field.isRequired && field.isRequired[actualId])) {
      return (
        this.userRightFields.includes((<string>field.id[refId]).toLowerCase()) &&
        !(field.exclude && field.exclude[actualId] == true)
      );
    } else {
      return this.validFunWithoutUserFields(field, refId, actualId);
    }
  };

  validFunWithoutUserFields = (
    field: VendorsFields,
    refId: keyof VendorsPlaceHolderTypeVal,
    actualId: keyof VendorsPlaceHolderTypeVal,
  ): boolean => {
    if (field.exclude && field.exclude[actualId] == true) {
      return false;
    } else {
      return true;
    }
  };

  getDatagridFields(): MappedField[] {
    return this.vendorsList
      .filter((field: VendorsFields): boolean => {
        return this.hasField(field, 'datagrid', 'datagrid');
      })
      .map((field: VendorsFields): MappedField => {
        return {
          field: (field.id?.datagrid as string) ?? '',
          headerText: (field.headerText?.datagrid as string) ?? '',
          isRequired: !!field.isRequired?.datagrid,
          type: field.dataType?.datagrid ? (field.dataType.datagrid as string) : 'string',
          visible: !!field.visible?.datagrid,
        };
      });
  }

  getCreateFormList(): MappedField[] {
    return this.vendorsList
      .filter((field: VendorsFields): boolean => {
        return this.hasField(field, 'datagrid', 'createForm');
      })
      .map((field: VendorsFields): MappedField => {
        return {
          controlType: field.controlType?.createForm
            ? (field.controlType.createForm as string)
            : '',
          field: (field.id?.datagrid as string) ?? '',
          headerText:
            (field.headerText?.createForm as string) ??
            (field.headerText?.datagrid as string) ??
            '',
          isRequired: !!field.isRequired?.createForm,
          visible: !!field.visible?.datagrid,
        };
      });
  }

  getEditFormList(): MappedField[] {
    return this.vendorsList
      .filter((field: VendorsFields): boolean => {
        return this.hasField(field, 'datagrid', 'editForm');
      })
      .map((field: VendorsFields): MappedField => {
        return {
          controlType: field.controlType?.editForm ? (field.controlType.editForm as string) : '',
          field: (field.id?.datagrid as string) ?? '',
          headerText:
            (field.headerText?.editForm as string) ?? (field.headerText?.datagrid as string) ?? '',
          visible: !!field.visible?.datagrid,
        };
      });
  }

  public readonly vendorsList: VendorsFields[] = [
    {
      dataType: { datagrid: 'actions' },
      exclude: { createForm: true },
      headerText: { datagrid: 'Actions' },
      id: { datagrid: 'actions' },
      isRequired: { datagrid: true },
      visible: { datagrid: true },
    },
    {
      controlType: { createForm: 'checkbox', editForm: 'checkbox' },
      dataType: { datagrid: 'checkbox' },
      headerText: { datagrid: 'Customer Approved' },
      id: { datagrid: 'approvedVendorByCustomer' },
      visible: { datagrid: true },
    },
    {
      // controlType: { editForm: 'checkbox' },
      dataType: { datagrid: 'checkbox' },
      exclude: { createForm: true },
      headerText: { datagrid: 'Enabled' },
      id: { datagrid: 'enabled' },
      visible: { datagrid: true },
    },
    {
      controlType: { createForm: 'checkbox', editForm: 'checkbox' },
      dataType: { datagrid: 'checkbox' },
      headerText: { datagrid: 'Partner Mode' },
      id: { datagrid: 'partnerMode' },
      visible: { datagrid: true },
    },
    // {
    //     id: { datagrid: 'id' },
    //     headerText: { datagrid: 'ID' },
    //     controlType: { editForm: 'simple' },
    //     dataType: { datagrid:'string' },
    //     visible: { datagrid: true },
    // },
    // {
    //     id: { datagrid: 'identityKey' },
    //     headerText: { datagrid: 'Identity Key' },
    //     controlType: { editForm: 'simple' },
    //     dataType: { datagrid: 'string' },
    //     visible: { datagrid: true },
    // },
    {
      // controlType: { editForm: 'simple' },
      dataType: { datagrid: 'string' },
      exclude: { createForm: true },
      headerText: { datagrid: 'Last Modified By' },
      id: { datagrid: 'lastModifiedBy' },
      visible: { datagrid: true },
    },
    {
      // controlType: { editForm: 'date' },
      dataType: { datagrid: 'dateUnchanged' },
      exclude: { createForm: true },
      headerText: { datagrid: 'Last Modified Date' },
      id: { datagrid: 'lastModifiedDate' },
      visible: { datagrid: true },
    },
    {
      controlType: { createForm: 'simple', editForm: 'simple' },
      dataType: { datagrid: 'string' },
      headerText: { datagrid: 'Means of Committing' },
      id: { datagrid: 'meansOfCommitting' },
      visible: { datagrid: true },
    },
    {
      controlType: { createForm: 'required' },
      dataType: { datagrid: 'string' },
      headerText: { datagrid: 'Vendor Code' },
      id: { datagrid: 'vendorCode' },
      isRequired: { createForm: true },
      visible: { datagrid: true },
    },
    {
      dataType: { datagrid: 'string' },
      exclude: { createForm: true },
      headerText: { datagrid: 'Vendor Name' },
      id: { datagrid: 'vendorName' },
      visible: { datagrid: true },
    },
    // {
    //     id: 'alias',
    //     headerText: 'Alias',
    //     controlType: 'simple',
    //     dataType: 'string',
    //     visible: true,
    // },
    {
      controlType: { createForm: 'simple', editForm: 'simple' },
      dataType: { datagrid: 'string' },
      headerText: { datagrid: 'Section Name' },
      id: { datagrid: 'sectionName' },
      visible: { datagrid: true },
    },
    {
      controlType: { createForm: 'simple', editForm: 'simple' },
      dataType: { datagrid: 'string' },
      headerText: { datagrid: 'Self Billing' },
      id: { datagrid: 'selfBilling' },
      visible: { datagrid: true },
    },
    // {
    //     id: 'vendorCode',
    //     headerText: 'Vendor Code',
    //     controlType: 'simple',
    //     dataType: 'string',
    //     visible: true,
    // },
    {
      dataType: { datagrid: 'flag' },
      exclude: { createForm: true },
      headerText: { datagrid: 'Flags' },
      id: { datagrid: 'flags' },
      visible: { datagrid: true },
    },
    {
      controlType: { createForm: 'simple', editForm: 'simple' },
      dataType: { datagrid: 'string' },
      headerText: { datagrid: 'Transportation Paid By' },
      id: { datagrid: 'transportationPaidBy' },
      visible: { datagrid: true },
    },
    {
      controlType: { createForm: 'simple' },
      dataType: { datagrid: 'string' },
      headerText: { datagrid: 'Vat' },
      id: { datagrid: 'vat' },
      visible: { datagrid: true },
    },
    // {
    //   id: { datagrid: 'email' },
    //   headerText: { datagrid: 'Email' },
    //   controlType: { createForm: 'required' },
    //   visible: { datagrid: true },
    //   // dataType: { datagrid: 'string' },
    //   isRequired: { createForm: true },
    //   exclude: { datagrid: true }
    // },
    {
      controlType: { createForm: 'number' },
      // dataType: { datagrid: 'number' },
      exclude: { datagrid: true },
      headerText: { datagrid: 'Phone' },
      id: { datagrid: 'phone' },
      visible: { datagrid: true },
    },
    // {
    //     id: 'lastModifiedBy',
    //     headerText: 'Last',
    //     controlType: 'simple',
    //     dataType: 'string',
    //     visible: true,
    // }
  ];

  getVendorPnFields(): MappedField[] {
    return this.vendorPNs
      .filter((field: VendorsFields): boolean => {
        return this.hasField(field, 'datagrid', 'datagrid');
      })
      .map((field: VendorsFields): MappedField => {
        return {
          field: (field.id?.datagrid as string) ?? '',
          headerText: (field.headerText?.datagrid as string) ?? '',
          type: field.dataType?.datagrid ? (field.dataType.datagrid as string) : 'string',
          visible: !!field.visible?.datagrid,
        };
      });
  }

  getPnFormFields(): MappedField[] {
    return this.vendorPNs
      .filter((field: VendorsFields): boolean => {
        return this.hasField(field, 'datagrid', 'nestedForm');
      })
      .map((field: VendorsFields): MappedField => {
        return {
          controlType: field.controlType?.nestedForm
            ? (field.controlType.nestedForm as string)
            : '',
          field: (field.id?.datagrid as string) ?? '',
          headerText:
            (field.headerText?.nestedForm as string) ??
            (field.headerText?.datagrid as string) ??
            '',
          visible: !!field.visible?.datagrid,
        };
      });
  }

  public readonly vendorPNs: VendorsFields[] = [
    {
      dataType: { datagrid: 'actions' },
      headerText: { datagrid: 'Actions' },
      id: { datagrid: 'actions' },
      visible: { datagrid: true },
    },
    {
      controlType: { nestedForm: 'simple' },
      dataType: { datagrid: 'string' },
      headerText: { datagrid: 'Part Number' },
      id: { datagrid: 'partNumber' },
      visible: { datagrid: true },
    },
    // {
    //     id: { datagrid: 'vendorCode' },
    //     headerText: { datagrid: 'Vendor Code' },
    //     controlType: { nestedForm: 'simple' },
    //     dataType: { datagrid:'string' },
    //     visible: { datagrid: true },
    // },
    {
      controlType: { nestedForm: 'simple' },
      dataType: { datagrid: 'string' },
      headerText: { datagrid: 'Section Name' },
      id: { datagrid: 'sectionName' },
      visible: { datagrid: true },
    },
    {
      // controlType: { nestedForm: 'flags' },
      dataType: { datagrid: 'flag' },
      headerText: { datagrid: 'Flags' },
      id: { datagrid: 'flags' },
      visible: { datagrid: true },
    },
  ];

  getVendorBuyerFields(): MappedField[] {
    return this.vendorBuyers
      .filter((field: VendorsFields): boolean => {
        return this.hasField(field, 'datagrid', 'datagrid');
      })
      .map((field: VendorsFields): MappedField => {
        return {
          field: (field.id?.datagrid as string) ?? '',
          headerText: (field.headerText?.datagrid as string) ?? '',
          type: field.dataType?.datagrid ? (field.dataType.datagrid as string) : 'string',
          visible: !!field.visible?.datagrid,
        };
      });
  }

  getBuyerFormFields(): MappedField[] {
    return this.vendorBuyers
      .filter((field: VendorsFields): boolean => {
        return this.hasField(field, 'datagrid', 'nestedBuyerForm');
      })
      .map((field: VendorsFields): MappedField => {
        return {
          controlType: field.controlType?.nestedBuyerForm
            ? (field.controlType.nestedBuyerForm as string)
            : '',
          field: (field.id?.datagrid as string) ?? '',
          headerText: (field.headerText?.datagrid as string) ?? '',
          visible: !!field.visible?.datagrid,
        };
      });
  }

  public readonly vendorBuyers: VendorsFields[] = [
    {
      dataType: { datagrid: 'actions' },
      headerText: { datagrid: 'Actions' },
      id: { datagrid: 'actions' },
      visible: { datagrid: true },
    },
    // {
    //   id: { datagrid: 'buyer' },
    //   headerText: { datagrid: 'Buyer' },
    //   dataType: { datagrid: 'string' },
    //   visible: { datagrid: true },
    // },
    {
      controlType: { nestedBuyerForm: 'd-partNumber' },
      dataType: { datagrid: 'string' },
      headerText: { datagrid: 'Part Number' },
      id: { datagrid: 'partNumber' },
      isRequired: { nestedBuyerForm: true },
      visible: { datagrid: true },
    },
    {
      controlType: { nestedBuyerForm: 'simple' },
      dataType: { datagrid: 'string' },
      exclude: { datagrid: true },
      headerText: { datagrid: 'Vendor Code' },
      id: { datagrid: 'vendorCode' },
      visible: { datagrid: true },
    },
    {
      controlType: { nestedBuyerForm: 'd-identityKey' },
      dataType: { datagrid: 'string' },
      exclude: { datagrid: true },
      headerText: { datagrid: 'Identity Key' },
      id: { datagrid: 'identityKey' },
      visible: { datagrid: true },
    },
    {
      // controlType: { nestedBuyerForm: 'simple' },
      dataType: { datagrid: 'string' },
      exclude: { datagrid: true },
      headerText: { datagrid: 'Contact Type' },
      id: { datagrid: 'contactType' },
      visible: { datagrid: true },
    },
    {
      controlType: { nestedBuyerForm: 'date' },
      dataType: { datagrid: 'dateUnchanged' },
      headerText: { datagrid: 'Valid From' },
      id: { datagrid: 'validFrom' },
      visible: { datagrid: true },
    },
    {
      controlType: { nestedBuyerForm: 'date' },
      dataType: { datagrid: 'dateUnchanged' },
      headerText: { datagrid: 'Valid To' },
      id: { datagrid: 'validTo' },
      visible: { datagrid: true },
    },
    {
      dataType: { datagrid: 'string' },
      headerText: { datagrid: 'First Name' },
      id: { datagrid: 'firstName' },
      visible: { datagrid: true },
    },
    {
      dataType: { datagrid: 'string' },
      headerText: { datagrid: 'Last Name' },
      id: { datagrid: 'lastName' },
      visible: { datagrid: true },
    },
    // {
    //   id: { datagrid: 'phone' },
    //   headerText: { datagrid: 'Buyer Phone' },
    //   dataType: { datagrid: 'number' },
    //   visible: { datagrid: true },
    // },
    {
      dataType: { datagrid: 'string' },
      headerText: { datagrid: 'Email' },
      id: { datagrid: 'email' },
      visible: { datagrid: true },
    },
  ];

  getVendorContactsFields(): MappedField[] {
    return this.vendorContacts
      .filter((field: VendorsFields): boolean => {
        return this.hasField(field, 'datagrid', 'datagrid');
      })
      .map((field: VendorsFields): MappedField => {
        return {
          field: (field.id?.datagrid as string) ?? '',
          headerText: (field.headerText?.datagrid as string) ?? '',
          type: field.dataType?.datagrid ? (field.dataType.datagrid as string) : 'string',
          visible: !!field.visible?.datagrid,
        };
      });
  }

  public readonly vendorContacts: VendorsFields[] = [
    {
      dataType: { datagrid: 'string' },
      headerText: { datagrid: 'NAME' },
      id: { datagrid: 'firstName' },
      visible: { datagrid: true },
    },
    {
      dataType: { datagrid: 'string' },
      headerText: { datagrid: 'SURNAME' },
      id: { datagrid: 'lastName' },
      visible: { datagrid: true },
    },
    {
      dataType: { datagrid: 'email' },
      headerText: { datagrid: 'EMAIL' },
      id: { datagrid: 'email' },
      visible: { datagrid: true },
    },
    {
      dataType: { datagrid: 'string' },
      headerText: { datagrid: 'CONTACT TYPE' },
      id: { datagrid: 'contactType' },
      visible: { datagrid: true },
    },
  ];

  getVendorNotificationFields(): MappedField[] {
    return this.vendorNotification
      .filter((field: VendorsFields): boolean => {
        return this.hasField(field, 'datagrid', 'datagrid');
      })
      .map((field: VendorsFields): MappedField => {
        return {
          field: (field.id?.datagrid as string) ?? '',
          headerText: (field.headerText?.datagrid as string) ?? '',
          type: field.dataType?.datagrid ? (field.dataType.datagrid as string) : 'string',
          visible: !!field.visible?.datagrid,
        };
      });
  }

  getNotificationFormFields(): MappedField[] {
    return this.vendorNotification
      .filter((field: VendorsFields): boolean => {
        return this.hasField(field, 'datagrid', 'nestedNotificationForm');
      })
      .map((field: VendorsFields): MappedField => {
        return {
          controlType: field.controlType?.nestedNotificationForm
            ? (field.controlType.nestedNotificationForm as string)
            : '',
          field: (field.id?.datagrid as string) ?? '',
          headerText: (field.headerText?.datagrid as string) ?? '',
          visible: !!field.visible?.datagrid,
        };
      });
  }

  public readonly vendorNotification: VendorsFields[] = [
    {
      dataType: { datagrid: 'actions' },
      headerText: { datagrid: 'Actions' },
      id: { datagrid: 'actions' },
      visible: { datagrid: true },
    },
    {
      controlType: { nestedNotificationForm: 'email' },
      dataType: { datagrid: 'string' },
      headerText: { datagrid: 'Email To' },
      id: { datagrid: 'emailTo' },
      visible: { datagrid: true },
    },
    {
      controlType: { nestedNotificationForm: 'emailCC' },
      dataType: { datagrid: 'string' },
      headerText: { datagrid: 'Email To CC' },
      id: { datagrid: 'emailToCC' },
      visible: { datagrid: true },
    },
    {
      controlType: { nestedNotificationForm: 'emailBCC' },
      dataType: { datagrid: 'string' },
      headerText: { datagrid: 'Email To BCC' },
      id: { datagrid: 'emailToBCC' },
      visible: { datagrid: true },
    },
    {
      controlType: { nestedNotificationForm: 'text' },
      dataType: { datagrid: 'string' },
      headerText: { datagrid: 'Description' },
      id: { datagrid: 'description' },
      visible: { datagrid: true },
    },
  ];
}
